export default __webpack_public_path__ + "static/media/ofc.5ab76526.png";